var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("group-title")))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-column-select", {
                    attrs: {
                      browse: _vm.browse,
                      model: _vm.model,
                      "is-server-column": "",
                    },
                    model: {
                      value: _vm.selectedProp,
                      callback: function ($$v) {
                        _vm.selectedProp = $$v
                      },
                      expression: "selectedProp",
                    },
                  }),
                  _c(
                    "w-button",
                    {
                      attrs: { icon: "plus", disabled: !_vm.selectedProp },
                      on: {
                        click: function ($event) {
                          return _vm.addProp()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.add")))]
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("hide-group-title") },
                    model: {
                      value: _vm.group.HideTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.group, "HideTitle", $$v)
                      },
                      expression: "group.HideTitle",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("start-new-page") },
                    model: {
                      value: _vm.group.CreateNewPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.group, "CreateNewPage", $$v)
                      },
                      expression: "group.CreateNewPage",
                    },
                  }),
                  _c("w-checkbox", {
                    attrs: {
                      value: !_vm.group.DontAddTotalRow,
                      label: _vm.$ct("add-total-row"),
                    },
                    on: {
                      input: function ($event) {
                        _vm.group.DontAddTotalRow = !$event
                      },
                    },
                  }),
                  _c("w-input", {
                    attrs: {
                      icon: "info",
                      fancy: "",
                      label: _vm.$ct("group-custom-text"),
                      "icon-tooltip": _vm.$ct("common.show-more-info"),
                    },
                    on: {
                      "icon-click": function ($event) {
                        return _vm.onCustomTextInfo()
                      },
                    },
                    model: {
                      value: _vm.group.CustomText,
                      callback: function ($$v) {
                        _vm.$set(_vm.group, "CustomText", $$v)
                      },
                      expression: "group.CustomText",
                    },
                  }),
                  _c(
                    "w-scroll-view",
                    { staticClass: "prop-list" },
                    [
                      _c(
                        "w-list",
                        [
                          _c(
                            "w-list-item",
                            {
                              key: "sortable-button",
                              staticClass: "sortable-button",
                            },
                            [
                              _c("w-list-item-text", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$ct("group-order-direction")) +
                                    " "
                                ),
                              ]),
                              _c(
                                "w-list-item-action",
                                [
                                  _c(
                                    "w-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          _vm.group.OrderASC =
                                            !_vm.group.OrderASC
                                        },
                                      },
                                    },
                                    [
                                      _vm.group.OrderASC
                                        ? _c("w-fa", {
                                            attrs: { icon: "sort-amount-down" },
                                          })
                                        : _c("w-fa", {
                                            attrs: { icon: "sort-amount-up" },
                                          }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-sortable",
                        {
                          attrs: {
                            tag: "w-list",
                            items: _vm.group.GroupByProps,
                            "target-class": "handle",
                          },
                          on: {
                            drop: function ($event) {
                              return _vm.onSorted()
                            },
                          },
                        },
                        _vm._l(_vm.group.GroupByProps, function (prop, i) {
                          return _c(
                            "w-list-item",
                            { key: "prop-" + i, attrs: { "show-handle": "" } },
                            [
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.getPropName(prop))),
                              ]),
                              _c(
                                "w-list-item-action",
                                [
                                  _c(
                                    "w-button",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: _vm.$ct("common.delete"),
                                          expression: "$ct('common.delete')",
                                        },
                                      ],
                                      staticClass: "danger",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeProp(i)
                                        },
                                      },
                                    },
                                    [_c("w-fa", { attrs: { icon: "trash" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.isValid, icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }